import React from 'react';
import { Island } from '@trevor/ui-components';
import { useDeriveHeadings } from '@/features/dataPresentation/navigation/connected-buttons/hooks';
import { BARLINE, PIE, PIVOT } from '@/components/charting/chartType.constants';
import ChartHolder from '@/components/ChartHolder';
import { SINGLE_VALUE } from '@/components/ChartHolder.constants';
import {
  Bar,
  BarLine,
  Line,
  Pie,
  Pivot,
  SingleValue,
  Stacked,
  Table,
} from './connected-buttons';

export const SharedDataPresentationNavigation = () => {
  const headings = useDeriveHeadings();
  const canPivot =
    headings && ChartHolder.canHandleHeadings(headings, PIVOT as any);
  const canBeSingleValue = ChartHolder.canHandleHeadings(
    headings,
    SINGLE_VALUE as any,
  );
  const canPie = ChartHolder.canHandleHeadings(headings, PIE as any);
  const canChart = headings && ChartHolder.canHandleHeadings(headings);
  const canBeBarLine =
    ChartHolder.canHave2ndYAxis(headings) &&
    ChartHolder.canHandleHeadings(headings, BARLINE as any);
  const canStacked = canChart && !canPie && headings.length === 3;
  return (
    <Island size="small">
      <Table />
      <Pivot hideIfDisabled available={canPivot} />
      <SingleValue hideIfDisabled available={canBeSingleValue} />
      <Pie hideIfDisabled available={canPie} />
      <Bar hideIfDisabled available={canChart} />
      <Line hideIfDisabled available={canChart} />
      <BarLine hideIfDisabled available={canBeBarLine} />
      <Stacked hideIfDisabled available={canStacked} />
    </Island>
  );
};
